
export class DatosEmpresa {
  rutEmpresa: string = "";
  razonSocial: string = "";
  emailContacto: string = "";
  telefonoContacto: string = "";
  financiadaSence: boolean = false;
}
